import classNames from 'classnames';
import { Button } from 'app/agriculture/components/Button/Button';
import { ChevronDownIcon, ChevronUpIcon, TimelineIcon } from 'app/agriculture/icons';
import './TimelineContainer.scss';
import {
    useTimelineDispatch,
    useTimelineExpandedState,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';

export function TimelineContainer({ children }: { children: React.ReactNode }) {
    const { expandTimeline, collapseTimeline } = useTimelineDispatch();
    const isTimelineExpanded = useTimelineExpandedState();
    const { id: viewMode } = useTimelineViewMode();

    return (
        <div className={classNames('TimelineContainer', `TimelineContainer--${viewMode}`)}>
            <Button
                className="TimelineContainer__button"
                theme="dark"
                startIcon={<TimelineIcon />}
                {...(isTimelineExpanded
                    ? {
                          onClick: collapseTimeline,
                          endIcon: <ChevronDownIcon />,
                          text: 'Collapse Timeline',
                      }
                    : {
                          onClick: expandTimeline,
                          endIcon: <ChevronUpIcon />,
                          text: 'Expand Timeline',
                      })}
            />
            {children}
        </div>
    );
}
